import React from "react";
import PropTypes from "prop-types";
import { Card } from "antd";
import { fetchFinancialYears, fetchFinancials } from "store/actions";
import { STATE_STATUS } from "constants/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoComputedRatioList from "./auto-computed-ratios";
class FinancialAnalysisRatios extends React.Component {
    state = {
        year: null,
        yearBefore: null,
        f1: null,
        f2: null
    };
    filteredFinancials = null;
    handleFinancialYearsFetch() {
        if (this.props.financialYearsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchFinancialYears(this.props.companyId);
        }
    }
    handleFinancialsFetch() {
        if (!this.props.financialsStatus) {
            this.props.fetchFinancials(this.props.companyId);
        }
    }

    componentDidMount() {
        this.handleFinancialYearsFetch();
        this.handleFinancialsFetch();
    }

    componentDidUpdate() {
        if (
            this.props.financialYearsStatus === STATE_STATUS.FETCHED &&
            this.props.financialsStatus === STATE_STATUS.FETCHED &&
            !this.filteredFinancials
        ) {
            this.getFinancials();
        }
    }

    getFinancials = () => {
        this.filteredFinancials = this.props.financials
            .filter(_ => _.is_active)
            .sort((f1, f2) => {
                if (
                    Number(f1.financial_year.name) >
                    Number(f2.financial_year.name)
                ) {
                    return -1;
                }
                return 1;
            });
        this.setState({
            f1: this.filteredFinancials.get(0),
            f2: this.filteredFinancials.get(1)
        });
    };

    render() {
        return (
            <Card className={"padless-card"} title={"Financial Analysis"}>
                <AutoComputedRatioList
                    size={"small"}
                    name="ratios"
                    f1={this.state.f1}
                    f2={this.state.f2}
                />
            </Card>
        );
    }
}

const mapStateToProps = (state, props) => ({
    financialYearsStatus: state.financials.get("financialYearsStatus"),
    financialYears: state.financials.get("financialYears"),
    financialsStatus: state.financials.getIn([
        "list",
        props.companyId,
        "status"
    ]),
    financials: state.financials.getIn(["list", props.companyId, "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchFinancialYears,
            fetchFinancials
        },
        dispatch
    );

FinancialAnalysisRatios.propTypes = {
    analysis: PropTypes.object,
    companyId: PropTypes.number,
    fetchFinancialYears: PropTypes.func,
    financialYearsStatus: PropTypes.string,
    financialYears: PropTypes.object,
    financialsStatus: PropTypes.string,
    financials: PropTypes.object,
    fetchFinancials: PropTypes.func
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinancialAnalysisRatios);
